import { colors } from '@nandosaus/constants';
import { filter, findLastIndex, get, isEmpty, map } from 'lodash';
import { observer } from 'mobx-react';
import { useRootStore } from '@nandosaus/state-management';
import React, { useEffect } from 'react';

import { Box, Flex } from '../../grid';
import { Button } from '../../button';
import { LoadingIndicator } from '../../icons/loading-indicator';
import { P } from '../../typography';
import { PastOrder } from '../../past-orders/past-order';

const SelectOrder = observer(() => {
  const { OrderHelpStore, PastOrdersStore, MemberStore } = useRootStore();

  const recentOrders = get(PastOrdersStore, 'recentOrders');
  const recentRefundableOrdersWithoutOpenSupportTickets = filter(recentOrders, 'isVisibleInHelpFlow');
  const hasRecentOrders = !isEmpty(recentRefundableOrdersWithoutOpenSupportTickets);

  useEffect(() => {
    if (!MemberStore.isSignedIn) {
      PastOrdersStore.loadOrders(OrderHelpStore.guestEmail);
    }
  }, [MemberStore, OrderHelpStore, PastOrdersStore]);

  const handleSelectOrder = order => {
    OrderHelpStore.setOrder(order);
    OrderHelpStore.goForward();
  };

  const handleCantFindOrders = () => {
    OrderHelpStore.setIsSupportTicketFlow(true);
    OrderHelpStore.goForward();
  };

  const isGuestFlow = !MemberStore.isSignedIn;

  const orderContent = hasRecentOrders ? (
    <Flex flexDirection="column" gap={1}>
      <P variant={3}>Which order?</P>
      <Flex flexDirection="column" backgroundColor="white" borderTop={isGuestFlow ? `1px solid ${colors.grey100}` : ''}>
        {map(recentRefundableOrdersWithoutOpenSupportTickets, (recentOrder, index) => {
          const showBorder = isGuestFlow
            ? true
            : index !== findLastIndex(recentRefundableOrdersWithoutOpenSupportTickets);

          return (
            <Box borderBottom={showBorder ? `solid 1px ${colors.grey100}` : ''} key={index}>
              <PastOrder
                px={isGuestFlow ? 0 : undefined}
                order={recentOrder}
                displayAsList
                handleClick={handleSelectOrder}
                showIsRefundedTag
              />
            </Box>
          );
        })}
      </Flex>
    </Flex>
  ) : null;

  return (
    <>
      {PastOrdersStore.loading ? (
        <LoadingIndicator />
      ) : (
        <>
          {orderContent}
          <P variant={4} mt={1}>
            If you can&#39;t see your order here, it probably means it&#39;s not eligible for an online refund. Please{' '}
            <Button
              variant="link"
              name="get in touch"
              onClick={() => handleCantFindOrders()}
              textVariant={4}
              style={{ padding: 0 }}
            >
              get in touch
            </Button>{' '}
            if you need more info.
          </P>
        </>
      )}
    </>
  );
});

export { SelectOrder };
